// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9205) return "static/chunks/9205-60e91f5badb48e0e.js";
	if (chunkId === 3176) return "static/chunks/3176-1a63e4259fb8eea9.js";
	if (chunkId === 518) return "static/chunks/518-46445d2b1a788fbe.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3524 ? "2170a4aa" : chunkId) + "." + {"3524":"d83fac6bb29a7e65","4828":"9a5a59f40e93e06c","5203":"77ddae019d833612","6208":"dcbc7e80cd61c5a6","6218":"64795a9c47fe7365","8436":"39669319b9f31b0a"}[chunkId] + ".js";
};